import { render, staticRenderFns } from "./UserRLSWrapper.vue?vue&type=template&id=7e4b059a"
import script from "./UserRLSWrapper.vue?vue&type=script&lang=js"
export * from "./UserRLSWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports